import '../../styles-new/pages/policy.scss';
